module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"edit_products_inventory":"Edit products inventory visibility","hidden":"Hidden","always":"Always","only_when_low":"Only when low"},"id":{"edit_products_inventory":"Edit tampilan inventaris produk","hidden":"Sembunyi","always":"Selalu","only_when_low":"Hanya saat rendah"}}')
  delete Component.options._Ctor
}
